module.exports = __webpack_public_path__ + "static/media/logout.b682b221.svg";